export default __webpack_public_path__ + "static/media/NeoNX110_LateralIzq.6fcac9dc.webp";